module.exports = __webpack_public_path__ + "media/images/new_marketing/amygdala-ad8dd51d99be539d3896c6c2d3a804d4a9a081f57d17e43623d8e66fffc044a2.png";